import { merge } from '../../helper';

import * as exBootstrap from '../../bootstrap';

import * as exCreate from './create';

// ----------------------------------------------------------------------------

function start(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig = {
        trigger: 'hover',
        timeout: true,
        bootstrap: {},
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Get bootstrap tooltip
    let bsTooltip = exBootstrap.getInstance('Tooltip', element);
    // If there is bootstrap tooltip
    if (bsTooltip) {
        bsTooltip.dispose();
    }

    // ------------------------------------------------------------------------

    // Settings
    exCreate.settings({ element: element }, defConfig);

    // Get bootstrap tooltip
    bsTooltip = exBootstrap.getCreateInstance('Tooltip', element, defConfig.bootstrap);

    // ------------------------------------------------------------------------

    return {
        element: element,
        bs: bsTooltip,
    };
}

// ----------------------------------------------------------------------------

export { start };
